import { HostListener, Component } from '@angular/core';

import {
    NavController,
    NavParams,
    PopoverController,
    ViewController,
    AlertController,
    LoadingController,
    ToastController,
    ModalController
} from 'ionic-angular';

import { Horse } from '../../../../model/horse';

import { AlertMessager } from "../../../../lib/alertMessager";
import { AddHorsePage } from '../../../horse/add-horse';
import { AccountHelper } from '../../../../lib/accountHelper';

import { HorseNomination } from '../../../../model/horseNomination';
import { HorseNominationPayment } from '../../../../model/horseNominationPayment';
import { Organization } from '../../../../model/organization';
import { NominationService } from '../../../../services/nomination.service';
import { HorseOwner } from '../../../../model/horseOwner';
import { HorseBreeder } from '../../../../model/horseBreeder';
import { Account } from '../../../../model/account';
import { HorseService } from '../../../../services/horse.service';
import { SearchComponent } from '../../../search/search.component';
import { NewMemberPage } from '../../rodeo/memberships/new-member';
import { NominationHorseSlot } from 'model/nominationHorseSlot';

@Component({
    selector: 'page-new-nomination',
    templateUrl: 'new-nomination.html'
})
export class NewNominationPage {
    selectedNomination: HorseNomination = new HorseNomination();

    selectedHorse: Horse;
    selectedAccount: Account;

    horses: Horse[];

    birthDate: string;
    submitAttempt: boolean;
    agreement: boolean;
    pendingName: boolean;

    editing: boolean;
    popoverActive: boolean;

    nominations: HorseNomination[] = [];
    createdNominations: HorseNomination[] = [];

    nominationHorseSlots: NominationHorseSlot[];

    organization: Organization;
    organizations: Organization[] = [];

    constructor(private nav: NavController, navParams: NavParams, private loadingController: LoadingController, private popoverController: PopoverController, private alertController: AlertController,
        private alert: AlertMessager, private nominationService: NominationService, private viewController: ViewController, private toast: ToastController, private modalController: ModalController,
        private horseService: HorseService) {
        this.organization = navParams.get("organization");
        this.organizations = navParams.get("organizations");
        this.nominationHorseSlots = this.organization.nominations[0].horseNominationSlots;

        let existingNomination = navParams.get("nomination");

        Object.assign(this.selectedNomination, existingNomination);

        if (existingNomination == null || existingNomination == undefined) {
            this.setupNewNomination();
        } else {
            this.editing = true;
            this.selectedHorse = this.selectedNomination.horse;
            this.selectedAccount = this.selectedNomination.account;
            this.birthDate = this.selectedHorse.birthDate.substring(0, this.selectedHorse.birthDate.indexOf('T'));

            if (!this.selectedHorse.aqhaId || this.selectedHorse.aqhaId.trim().length == 0)
                this.pendingName = true;

            this.selectedNomination.payments.forEach(payment => {
                payment.transactionDate = payment.transactionDate.substring(0, payment.transactionDate.indexOf('T'));
            })
        }

        console.log("selectedHorse.sex: ", this.selectedHorse.sex);

        this.nominations.push(this.selectedNomination);
    }

    setupNewNomination() {
        this.birthDate = "";

        this.selectedNomination = new HorseNomination();
        this.selectedHorse = new Horse();
        this.selectedAccount = null;
        this.submitAttempt = false;

        this.selectedHorse.aqhaId = ""
        this.selectedHorse.owner = new HorseOwner();
        this.selectedHorse.owner.name = "";
        this.selectedHorse.owner.phone = "";
        this.selectedHorse.owner.emailAddress = "";
        this.selectedHorse.owner.city = "";
        this.selectedHorse.owner.address = "";
        this.selectedHorse.owner.state = "";
        this.selectedHorse.owner.zip = "";

        this.selectedHorse.breeder = new HorseBreeder();
        this.selectedHorse.breeder.name = "";
        this.selectedHorse.breeder.phone = "";
        this.selectedHorse.breeder.emailAddress = "";
        this.selectedHorse.breeder.city = "";
        this.selectedHorse.breeder.address = "";
        this.selectedHorse.breeder.state = "";
        this.selectedHorse.breeder.zip = "";

        this.selectedHorse.sire = new Horse();
        this.selectedHorse.sire.name = "";

        this.setupHorse(this.selectedHorse);
    }

    setupHorse(horse: Horse) {
        if (!horse.birthDate)
            horse.birthDate = new Date().toDateString();
        if (!horse.sex)
            horse.sex = 'Stallion';
        if (!horse.sire)
            horse.sire = new Horse();
        if (!horse.dam)
            horse.dam = new Horse();
        if (!horse.dam.sire)
            horse.dam.sire = new Horse();
        if (!horse.owner)
            horse.owner = new HorseOwner();
        if (!horse.breeder)
            horse.breeder = new HorseBreeder();
    }

    selectNomination(index) {
        this.selectedNomination = this.nominations[index];
    }

    addNewNomination() {
        this.setupNewNomination();
        this.nominations.push(this.selectedNomination);
    }

    removeEntry(entry) {
        let index = this.nominations.indexOf(entry);
        this.nominations = this.nominations.filter(x => x != entry);
        this.selectedNomination = this.nominations.length > index ? this.nominations[index] : this.nominations[index - 1];
    }

    async openSearchPopover(searchType, title) {
        if (this.popoverActive)
            return;

        let configOptions = {};

        if (searchType != 'account' && !this.selectedAccount) {
            this.alert.showError("Missing Nominator", "You must select a nominator first.");
            return;
        }

        if (searchType != 'horse' && !this.selectedHorse) {
            this.alert.showError("Missing Horse", "You must select a horse first.");
            return;
        }

        if (searchType === 'damSires' && !this.selectedHorse.dam) {
            this.alert.showError("Missing Dam", "You must select a dam first.");
            return;
        }

        this.popoverActive = true;

        switch (searchType) {
            case 'horse':
                configOptions = {
                    config: {
                        searchTitle: title,
                        horseSearch: true,
                        userSearch: true,
                        addNew: true
                    },
                    userIds: [this.selectedAccount.id],
                    userHorses: true
                }
                break;
            case 'sires':
            case 'damSires':
                configOptions = {
                    config: {
                        searchTitle: title,
                        horseSearch: true,
                        addNew: true
                    },
                    siresOnly: true
                }
                break;
            case 'dams':
                configOptions = {
                    config: {
                        searchTitle: title,
                        horseSearch: true,
                        addNew: true
                    },
                    damsOnly: true
                }
                break;
            case 'breeder':
                configOptions = {
                    config: {
                        searchTitle: title,
                        breederSearch: true,
                        addNew: true
                    }
                }
                break;
            case 'owner':
                configOptions = {
                    config: {
                        searchTitle: title,
                        ownerSearch: true,
                        addNew: true
                    }
                }
                break;
            case 'account':
                configOptions = {
                    config: {
                        searchTitle: title,
                        userSearch: true,
                        addNew: true
                    },
                    organizations: this.organizations
                }
                break;
        }

        let popover = this.popoverController.create(SearchComponent, configOptions, { cssClass: 'app-search' });

        popover.present();

        await popover.onWillDismiss(async (data) => {
            this.popoverActive = false;

            if (data) {
                switch (searchType) {
                    case 'horse':
                        /*
                        if (!data.id) {
                            if (this.popoverActive)
                                return;

                            this.popoverActive = true;

                            let popover = this.modalController.create(AddHorsePage, {
                                accountId: AccountHelper.instance().getAccountId(),
                                horse: data
                            }, { cssClass: 'page-add-horse' });

                            await popover.present();

                            popover.onDidDismiss((data) => {
                                this.popoverActive = false;

                                if (data != null && data.horse != undefined) {
                                    this.selectedHorse = (data.horse as Horse);
                                    this.setupHorse(this.selectedHorse);
        
                                    if (this.selectedHorse.birthDate)
                                        this.birthDate = this.selectedHorse.birthDate.substring(0, this.selectedHorse.birthDate.indexOf('T'));
                                }
                            })


                        } else {
                            */
                            this.selectedHorse = data;
                            this.setupHorse(this.selectedHorse);

                            if (this.selectedHorse.birthDate)
                                this.birthDate = this.selectedHorse.birthDate.substring(0, this.selectedHorse.birthDate.indexOf('T'));
                        //}
                        break;
                    case 'sires':
                        this.selectedHorse.sire = data;
                        break;
                    case 'dams':
                        if (!data.sire) {
                            data.sire = new Horse();
                            data.sex = 'Mare';
                        }

                        this.selectedHorse.dam = data;
                        break;
                    case 'damSires':
                        if (!data.sex)
                            data.sex = 'Stallion';

                        this.selectedHorse.dam.sire = data;
                        break;
                    case 'breeder':
                        this.selectedHorse.breeder = data;
                        break;
                    case 'owner':
                        this.selectedHorse.owner = data;
                        break;
                    case 'account':
                        if (data.id > 0)
                            this.selectedAccount = data;
                        else {
                            let accountCallBack = ((newAccount) => {
                                if (newAccount != null)
                                    this.selectedAccount = newAccount;
                            });

                            let entryModal = this.popoverController.create(NewMemberPage, { account: null, organizations: this.organizations, firstName: data.firstName, lastName: data.lastName, callback: accountCallBack }, { cssClass: 'page-new-member', enableBackdropDismiss: true });

                            entryModal.present();
                            entryModal.onDidDismiss((newAccount) => {
                                this.popoverActive = false;
                            });
                        }
                        break;
                }
            }
        })
    }

    matchStrings(a: any, b: any) {
        return a.toLowerCase() === b.toLowerCase();
    }

    async searchByAQHAId() {
        if (this.popoverActive) {
            return;
        }

        const loader = await this.loadingController.create({
            content: ("Searching AQHA for horse...")
        });

        await loader.present();

        try {
            let horseData = await this.horseService.searchHorseByAQHAId(this.selectedHorse.id, this.selectedHorse.aqhaId);

            console.log(horseData);

            if ((horseData as any).error) {
                if ((horseData as any).error == 'Invalid registration number.')
                    this.alert.showError("AQHA Service Error", (horseData as any).error);
                else {
                    this.alert.showError("AQHA Search Result", "AQHA Lookup Service is currently down.");
                }
            } else if (!horseData.name) {
                this.alert.showError("AQHA Search Result", "AQHA Lookup Service is currently down.");
            } else {
                var horseId = this.selectedHorse.id;
                this.selectedHorse = horseData;
                this.selectedHorse.id = horseId;
                this.updateHorseInfo(this.selectedHorse);
            }
        } catch (error) {
            this.alert.showError("AQHA Search Result", "AQHA Lookup Service is currently down.");
        }

        this.popoverActive = false;

        await loader.dismiss();
    }

    updateHorseInfo(horse: Horse) {
        if (horse.id)
            this.editing = true;

        if (this.selectedHorse.birthDate) {
            this.birthDate = this.selectedHorse.birthDate.substring(0, this.selectedHorse.birthDate.indexOf('T'));
        }
    }

    delete() {
        let alert = this.alertController.create({
            title: 'Nomination Removal',
            message: 'Are you sure you want to remove this entry?',
            buttons: [
                {
                    text: 'Yes',
                    handler: () => {
                        0
                        this.nominationService.deleteHorseNomination(AccountHelper.instance().getAccountId(), this.selectedNomination.id)
                            .then(data => {
                                this.setupNewNomination();
                            }), error => {
                                this.alert.showError("Nomination Removal Error", error);
                            };
                    }
                },
                {
                    text: 'No',
                    role: 'cancel',
                    handler: () => { }
                }]
        });

        alert.present();
    }

    create(pay: boolean) {
        this.submitAttempt = true;

        let errorMessage;
        if (!this.selectedHorse.name)
            errorMessage = "<p>You must input the horse name.</p>";

        if (!this.selectedHorse.sire.name)
            errorMessage = (errorMessage ? errorMessage + "\n" : "") + "<p>You must select a sire.</p>";

        if (!this.selectedHorse.dam.name)
            errorMessage = (errorMessage ? errorMessage + "\n" : "") + "<p>You must input the dam name.</p>";

        if (!this.birthDate)
            errorMessage = (errorMessage ? errorMessage + "\n" : "") + "<p>You must select a date of birth for your horse.</p>";

        if (!this.selectedHorse.sex)
            errorMessage = (errorMessage ? errorMessage + "\n" : "") + "<p>You must select a sex for your horse.</p>";

        if (!this.pendingName && !this.selectedHorse.aqhaId)
            errorMessage = (errorMessage ? errorMessage + "\n" : "") + "<p>You must input your registration number.</p>";

        if (!this.agreement && this.organization.id == 21)
            errorMessage = (errorMessage ? errorMessage + "\n" : "") + "<p>You must agree to the Foal Agreement.</p>";

        if (errorMessage) {
            this.alert.showError("Error Creating Nomination", errorMessage);
            return;
        }

        let loader = this.loadingController.create({
            content: (this.editing ? 'Editing' : 'Creating') + ' nomination...',
        });

        loader.present();

        this.selectedHorse.birthDate = new Date(this.birthDate).toISOString();

        if (this.selectedNomination.payments) {
            this.selectedNomination.payments.forEach(payment => {
                payment.transactionDate = new Date(payment.transactionDate).toISOString();
            });
        }

        if (this.editing) {
            this.nominationService.updateHorseNomination(this.selectedNomination)
                .then(data => {
                    if ((data as any).message != null && (data as any).message != undefined) {
                        this.alert.showError("Nomination Update Failed", (data as any).message);
                        loader.dismiss();
                    } else {
                        this.toast.create({
                            message: 'Nomination was edited successfully.',
                            duration: 1500,
                            position: 'middle'
                        }).present();

                        this.viewController.dismiss({ entry: data });
                        loader.dismiss();
                    }
                }, error => {
                    this.alert.showError("Nomination Update Error", error);
                    loader.dismiss();
                });
        } else {
            this.selectedNomination.nominationId = this.organization.nominations[0].id;
            this.selectedNomination.horse = this.selectedHorse;
            this.selectedNomination.horseId = this.selectedHorse.id;
            this.selectedNomination.accountId = this.selectedAccount.id;

            let processNominationResponse = (data => {
                loader.dismiss();
                if ((data as any).message != null && (data as any).message != undefined) {
                    this.alert.showError("Nomination Create Failed", (data as any).message);
                } else {
                    if (this.organization.paymentRequiredOnEntry && pay) {
                        let callback = (removed) => { this.viewController.dismiss(); };

                        callback = (removed) => {
                            if (removed)
                                return;

                            let addedNomination = (data as HorseNomination);

                            let alert = this.alertController.create({
                                title: 'Nomination Added!',
                                message: 'Would you like to add more nominations?',
                                buttons: [
                                    {
                                        text: 'Yes',
                                        handler: () => {
                                            this.createdNominations.push(addedNomination);
                                            setTimeout(() => {
                                                this.setupNewNomination();
                                            }, 0);
                                        }
                                    },
                                    {
                                        text: 'No',
                                        role: 'cancel',
                                        handler: () => {
                                            setTimeout(() => {
                                                this.setupNewNomination();
                                            }, 0);
                                        }
                                    }]
                            });

                            alert.present();
                        };
                    } else {
                        let addedNomination = (data as HorseNomination[])[0];

                        let alert = this.alertController.create({
                            title: 'Nomination Confirmed!',
                            message: 'Would you like to add more nominations?',
                            buttons: [
                                {
                                    text: 'Yes',
                                    handler: () => {
                                        this.createdNominations.push(addedNomination);
                                        setTimeout(() => {
                                            this.setupNewNomination();
                                        }, 0);
                                    }
                                },
                                {
                                    text: 'No',
                                    role: 'cancel',
                                    handler: () => {
                                        setTimeout(() => {
                                            this.setupNewNomination();
                                        }, 0);
                                    }
                                }]
                        });

                        alert.present();
                    }
                }
            });

            this.nominationService.addHorseNomination(this.selectedAccount.id, this.selectedNomination, pay)
                .then((data => processNominationResponse(data))
                    , error => {
                        this.alert.showError("Nomination Create Error", error);
                        loader.dismiss();
                    });
        }
    }

    addPayment() {
        if (!this.selectedNomination.payments)
            this.selectedNomination.payments = [];

        this.selectedNomination.payments.push(new HorseNominationPayment());
    }

    cancel() {
        this.viewController.dismiss({ nominations: this.createdNominations });
    }

    back() {
        this.viewController.dismiss({ nominations: this.createdNominations });
    }

    _bdClick() {
        return this.viewController.dismiss({ nominations: this.createdNominations });
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this.viewController.isLast() && !this.popoverActive) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/organization/nominations/new-nomination.ts